module.exports = __webpack_public_path__ + "static/media/icon-dashboard-commission-projected.84ef53e2.svg";